import categoryDataSlice from './slices/categoryDataSlice';
import filtersSlice from './slices/filtersSlice';
import productsTableSlice from '../components/ProductsTable/productsTableSlice';
import wdValidatorSlice from './slices/wdValidatorSlice';
import chartFilterSlice from './slices/chartFilterSlice';
import chatBotSlice from './slices/chatBotSlice';

const rootReducer = {
	categoryData: categoryDataSlice,
	filters: filtersSlice,
	chartFilters: chartFilterSlice.reducer,
	productsTable: productsTableSlice,
	wdValidator: wdValidatorSlice,
	chatBot: chatBotSlice
};

export default rootReducer;
